import ChatWebComponent from "./components/web-components/chat";
import ChatModalWebComponent from "./components/web-components/chat-modal-widget";
import ChatTriggerWebComponent from "./components/web-components/chat-trigger";
import DebugDashboardWebComponent from "./components/web-components/debug-dashboard";
import PlaygroundWebComponent from "./components/web-components/playground";
import SearchResultsWebComponent from "./components/web-components/search-results";
import { env } from "@/env";
import "@qa-app/core/widget-font-assets";
import { Sentry } from "./instrument";

const resolveApiUrl = () => {
  const selector = [
    "pollen-chat[api-url]",
    "pollen-chat-trigger[api-url]",
    "pollen-chat-modal[api-url]",
    "pollen-search-results[api-url]",
  ].join(", ");

  const element = document.querySelector<HTMLElement>(selector);
  const apiUrl = element?.getAttribute("api-url")?.trim();
  return apiUrl || env.API_URL;
};

const API_URL = resolveApiUrl();

// Function to safely register custom elements (avoid "already used" errors)
const safeDefineCustomElement = (
  name: string,
  constructor: CustomElementConstructor,
) => {
  if (!customElements.get(name)) {
    customElements.define(name, constructor);
  }
};

safeDefineCustomElement("pollen-debug-dashboard", DebugDashboardWebComponent);
safeDefineCustomElement("pollen-playground", PlaygroundWebComponent);
safeDefineCustomElement("pollen-chat-trigger", ChatTriggerWebComponent);

fetch(`${API_URL}/health`)
  .then((res) => {
    return res.json();
  })
  .then((data) => {
    // if health is ok, register all widget custom elements
    if (data.status === "ok") {
      safeDefineCustomElement("pollen-chat", ChatWebComponent);
      safeDefineCustomElement("pollen-chat-modal", ChatModalWebComponent);
      safeDefineCustomElement("pollen-search-results", SearchResultsWebComponent);
    }
    return data;
  })
  .catch((error) => {
    // Capture health check failures with Sentry
    Sentry.captureException(error, {
      tags: {
        component: "widget-initialization",
        context: "health-check",
      },
      extra: {
        apiUrl: API_URL,
      },
    });
    console.error("Health check failed:", error);
  });
